import { config } from "./config"

export const utils = {
    getUpiUrl,
    getReferrer,
    getImageUrl,
    getStoreUrl,
    getshopReferrerUrl
}

function getImageUrl(fileName = "") {
    return `${config.apiUrl}/s3/download?file_name=${fileName}`
}

function getReferrer(primary_num = "", shop_id = ""){
    if(!primary_num || !shop_id){
        return '';
    }
    let shopKey = btoa(`${shop_id}`);
    let referrer = btoa(`${primary_num}_${shopKey}`);
    return referrer;
}

function getshopReferrerUrl(primary_num = "", shop_id = ""){
    const referrer = getReferrer(primary_num, shop_id);
    if(!referrer){
        return config.referrerUrl;
    }
    //To Refer shop SOLO-WEB
    return `${config.referrerUrl}&type=menu&referrer=${referrer}&utm_source=solo-web`;
}

function getStoreUrl(primary_num = "", shop_id = ""){
    const referrer = getReferrer(primary_num, shop_id);
    if(!referrer){
        return config.referrerUrl;
    }
    //To Refer shop via APP download
    return `${config.referrerUrl}&referrer=${referrer}&utm_source=solo-web&target=app-download`;
}

function getUpiUrl(data = {}){
    const { upi_id, name } = data;
    if(!upi_id){
        return '';
    }
    let url = `upi://pay?pa=${upi_id}&cu=INR`;
    url += (name ? `&pn=${name}` : '');
    return url;
}